import { render, staticRenderFns } from "./folder-cloud.vue?vue&type=template&id=4a440f46&"
import script from "./folder-cloud.vue?vue&type=script&lang=js&"
export * from "./folder-cloud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a440f46')) {
      api.createRecord('4a440f46', component.options)
    } else {
      api.reload('4a440f46', component.options)
    }
    module.hot.accept("./folder-cloud.vue?vue&type=template&id=4a440f46&", function () {
      api.rerender('4a440f46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/folder-cloud.vue"
export default component.exports